import { createFileRoute } from '@tanstack/react-router';

import { Building } from '@mint-lib/icons';
import { buildGuards, hasPermission } from '@mint-lib/routing-guards';

// TODO(STZF-23): fix guard duplication with sidebar in permissions refactoring
// TODO(STZF-23): the sidebar shows "Agency Profile" (/agency-hub) to agency
// companies instead; this entry still shows for them and redirects there
const sidebarGuard = buildGuards(hasPermission('financialDataFeature:view'));

export const Route = createFileRoute('/_secured/company-profile/')({
  staticData: {
    commandMeta: ({ t, check }) => {
      if (!check(sidebarGuard)) {
        return;
      }

      return {
        title: t('Company Profile'),
        keywords: [t('settings'), t('users')],
        icon: Building,
      };
    },
  },
});
